// extracted by mini-css-extract-plugin
export default {"form":"FormSendEmailModal_form__O7sBx","formBody":"FormSendEmailModal_formBody__COPM1","buttonDelete":"FormSendEmailModal_buttonDelete__CpqiK"};